<style scoped>
    .showImg {
        position: relative;
        float: left;
        margin-right: 10px;
    }
    .showImg .demo-upload-list-cover {
        width: 100px;
        height: 100px;
        padding: 33px 20px;
    }
    .showImg .demo-upload-list-cover i {
        font-size: 30px;
    }
    .addBtn {
        float: left;
        margin-right: 10px;
    }

    .addimg-items{
        width: 100px;
    }
</style>

<template>
    <div>
        <form ref="uploadForm" id="uploadForm" style="display:inline;">
            <input type="file"
                    id="fileId"
                    ref="addPicFile"
                    name="file"
                    accept="image/jpg,image/jpeg,image/png,image/bmp"
                    style="display:none;"
                    @change="addPic"/>
        </form>

        <div class="showImg" v-for="item in list" :key="item.src">
            <img class="addimg-items"
                    v-show="photoList.length > 0"
                    :src="item.src"/>
<!--                    @mouseenter="enter(item)"-->
<!--                    @mouseleave="leave(item)"-->
            <div class="demo-upload-list-cover"
                    v-show="item.imgHover">
<!--                    @mouseenter="enter(item)"-->
<!--                    @mouseleave="leave(item)"-->
<!--                <Icon type="ios-eye" @click="showImg(item.src)" />-->
<!--                <Icon type="ios-trash" @click="reset(index)" />-->
            </div>
        </div>
<!--        <input type="hidden" name="imgUrl" v-model="imgUrl"/>-->
<!--        <img-->
<!--                class="addimg-items addBtn"-->
<!--                v-show="photoList.length < 5"-->
<!--                src="@/assets/logo.png"-->
<!--                @click="$refs.addPicFile.click()"-->
<!--        />-->
        <input type="button" value="选择图片" class="btn-file" @click="$refs.addPicFile.click()"/>
<!--        <Modal title="图片详情" v-model="visible">-->
<!--            <img :src="show.photo" v-if="visible" style="width: 100%" />-->
<!--            <div slot="footer"></div>-->
<!--        </Modal>-->
    </div>
</template>

<script>
    // import common from "@/assets/js/common";
    // import Http from "@/utils/Network/Http";
    import layer from "layui-layer";

    export default {
        name: "upload",
        components: {},
        props: ["photo"],
        data: function () {
            return {
                visible: false,
                show: {
                    photo: ""
                },
                photoList: [],
                list: [],
                logo: null
            };
        },
        computed: {},
        watch: {},
        created: function(){
            console.log('upload created');
        },
        methods: {
            //移入
            // enter(item) {
            //     item.imgHover = true;
            // },
            // //移出
            // leave(item) {
            //     item.imgHover = false;
            // },
            // //查看大图
            // showImg(src) {
            //     this.visible = true;
            //     this.show.photo = src;
            // },
            //添加图片
            addPic() {
                this.logo = null;
                let file = this.upload(this.$refs.addPicFile);
                let reader = new FileReader();
                reader.onload = e => {
                    let img = new Image();
                    img.src = e.target.result;
                    img.onload = () => {
                        let imgSrc = this.compress(img);
                        // let imgBin = e.target.result;
                        let imgData = {};
                        imgData.base64Data = imgSrc;
                        // imgData.file = imgBin;
                        this.$options.methods.uploadPic.bind(this)(imgData);
                        if(this.list.length == 1){
                            this.list= [{
                                src: imgSrc,
                                imgHover: false
                            }];
                            // this.list[0].src = imgSrc;
                        } else {
                            this.list.push({
                                src: imgSrc,
                                imgHover: false
                            });
                            // this.photoList.push({
                            //     src: imgSrc,
                            //     imgHover: false
                            // });
                        }
                        this.$refs.addPicFile.value = "";

                    };
                };
                reader.readAsDataURL(file);
                this.$parent.selectFile = true;
                // reader.readAsBinaryString(file);
            },
            uploadPic(data) {
                let _this = this;
                this.$http.post(`/image/base64Upload`, data, function (data) {
                    console.log(data)
                    if(data.code == '000000'){
                        _this.logo = data.data.url;
                        // _this.$emit('logo', data.data.url);
                        layer.msg("图片上传成功！", {fixed: false});
                    } else {
                        layer.msg(data.message, {fixed: false});
                    }
                    // this.list.push({
                    //     src: data.message,
                    //     imgHover: false
                    // });
                    // this.$emit("addPic", this.list);
                }, function (data) {
                    console.log(data)
                });
                // res.then(data => {
                //     // 因为我需要鼠标悬浮图片显示预览和删除按钮， 所以需要imgHover参数
                //     this.list.push({
                //         src: data.message,
                //         imgHover: false
                //     });
                //     this.$emit("addPic", this.list);
                // });
            },
            reset(index) {
                this.list.splice(index, 1);
                this.$emit("resetPic", this.list);
            },
            // 清空图片
            clearPic() {
                this.photoList = [];
                this.$emit("clearPic", this.photoList);
            },
            //图片压缩
            compress(img) {
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                let width = img.width;
                let height = img.height;
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);
                let type = "image/jpeg";
                let img64 = canvas.toDataURL(type, 0.3);
                return img64;
            },
            //图片上传
            upload(img) {
                //判断是否支持FileReader
                if (!window.FileReader) {
                    layer.msg("您的设备不支持图片预览功能，如需该功能请升级您的设备！",{fixed: false});
                    return;
                }
                let file = img.files[0];
                //是否是图片
                let imageType = /^image\//;
                if (!imageType.test(file.type)) {
                    layer.msg("请选择图片！",{fixed: false});
                    return;
                }
                return file;
            }
        },
        mounted() {
            // 因为修改调用查询方法返回过来的数据会慢一点，所以我延迟赋值了，否则图片将不会展示
            setTimeout(() => {
                this.photoList = this.photo;
                this.list = this.photo;
                if(this.photo && this.photo.length > 0){
                    this.logo = this.photo[0].src;
                }
            }, 300);
        }
    };
</script>